module.exports = __webpack_public_path__ + "static/media/ticket-promo.4a1b24dd.png";